// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__PyJj0","modal":"Modal_modal__cMGC4","slide-down":"Modal_slide-down__+SWT-"};